import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

import { bizApi } from '../BizApi'
import { BizWidget } from '../widgets/BizWidget'

import { BizActionButtonTerminateAccount } from './BizActionButtonTerminateAccount'

export function BizTerminateAccountForm() {
  const {
    data: { company },
  } = bizApi.company.get.useSuspenseQuery()
  const companyName = company.name

  return (
    <BizWidget title={t`Permanently delete account`}>
      <div className="prose prose-small pb-4">
        <p>
          <Trans>
            This will permanently delete all users accounts and the business
            account itself
          </Trans>{' '}
          {companyName}.
        </p>
        <p>
          <Trans>
            All files and users associated with this accounts will be deleted
            permanently
          </Trans>
          .
        </p>
        <p>
          <Trans>
            You will need to confirm your password to complete this operation.
          </Trans>
        </p>
      </div>
      <BizActionButtonTerminateAccount />
    </BizWidget>
  )
}
